import React from 'react'
import ReactApexChart from "react-apexcharts"
import Props from 'prop-types'
/*
	<LineGraph height={400} title="Graph" data={[{name:"Hello",data:[121,222]]} items={["Min Price","Max Price"]}/>
*/
function LineGraph(props) {
	return (
		<div>
			<ReactApexChart options={{
				chart: {
					type: 'line',
					height: props.height,
					toolbar: {
						tools: {
							download: false,
							selection: false,
							zoom: true,
							zoomin: true,
							zoomout: true,
							pan: true,
							reset: true,
							customIcons: []
						},
						autoSelected: 'zoom',
						show:true
					},
					
				},
				title: {
					text: props.title,
					align: 'left'
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					curve: 'straight'
				},
				grid: {
					row: {
						colors: ['#f3f3f3', 'transparent'],
						opacity: 0.5
					},
				},
				xaxis: {
					categories: props.items,
				},
				fill: {
					opacity: 1
				},
			}} series={props.data} type="line" height={props.height} />
		</div>
	)
}


LineGraph.propTypes = {
	data : Props.array.isRequired,
	items : Props.array.isRequired,
	title:Props.string.isRequired,
	y:Props.string.isRequired,
	height:Props.number.isRequired
}

LineGraph.defaultProps = {
	y: "Price",
	title:'Price Movement',
	height:350
}

export {
	LineGraph
}

export default LineGraph
